"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _from = require("babel-runtime/core-js/array/from");

var _from2 = _interopRequireDefault(_from);

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _effects = require("redux-saga/effects");

var _bookingDataActions = require("actions/bookingDataActions");

var _apiHelper = require("api/api-helper");

var _selectors = require("selectors");

var _departureServicesDataActions = require("actions/departureServicesDataActions");

var _roomingListsDataActions = require("actions/roomingListsDataActions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchLinkedBookingsCustomerData);

// Filter each linked-booking entry down to customers whose ids are currently allowed for rooming.
var filterBookingCustomersByAllowedIds = function filterBookingCustomersByAllowedIds(bookingEntries, allowedIds) {
    return bookingEntries.map(function (entry) {
        if (!Array.isArray(entry.bookingCustomersData)) {
            return entry;
        }

        return (0, _extends3.default)({}, entry, {
            bookingCustomersData: entry.bookingCustomersData.filter(function (cust) {
                return allowedIds.has(String(cust.id));
            })
        });
    });
};

// Grab a list of bookings ids
// fetch bookings of those ids
function fetchLinkedBookingsCustomerData() {
    var _this = this;

    var _loop, _ret;

    return _regenerator2.default.wrap(function fetchLinkedBookingsCustomerData$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _loop = /*#__PURE__*/_regenerator2.default.mark(function _loop() {
                        var _ref, linkedBookingsData, departureServicesById, authToken, locale, bookingIds, linkedBookingCustomers, filteredLinkedBookingCustomers, _ref2, roomingListAction, roomingListData, roomingListCustomerIdsSet, myOwnRoomCustomerIdsSet, allowedRoomingCustomerIds, roomingEligibleLinkedBookingCustomers;

                        return _regenerator2.default.wrap(function _loop$(_context) {
                            while (1) {
                                switch (_context.prev = _context.next) {
                                    case 0:
                                        _context.next = 2;
                                        return (0, _effects.take)(_bookingDataActions.LINKED_BOOKINGS_DATA_RECEIVED);

                                    case 2:
                                        _ref = _context.sent;
                                        linkedBookingsData = _ref.linkedBookingsData;
                                        _context.next = 6;
                                        return (0, _effects.select)(_selectors.getDepartureServicesById);

                                    case 6:
                                        departureServicesById = _context.sent;

                                        if ((0, _keys2.default)(departureServicesById).length) {
                                            _context.next = 10;
                                            break;
                                        }

                                        _context.next = 10;
                                        return (0, _effects.take)(_departureServicesDataActions.DEPARTURE_SERVICES_DATA_RECEIVED);

                                    case 10:
                                        _context.next = 12;
                                        return (0, _effects.select)(function (state) {
                                            return state.user.authorization.token;
                                        });

                                    case 12:
                                        authToken = _context.sent;
                                        _context.next = 15;
                                        return (0, _effects.select)(function (state) {
                                            return state.intl.locale;
                                        });

                                    case 15:
                                        locale = _context.sent;
                                        bookingIds = (0, _keys2.default)(linkedBookingsData).map(function (bookingId) {
                                            return bookingId;
                                        });
                                        _context.next = 19;
                                        return bookingIds.map(function (bookingId) {
                                            return (0, _effects.call)(_apiHelper.getLinkedBookingCustomersData, bookingId, authToken, locale);
                                        });

                                    case 19:
                                        linkedBookingCustomers = _context.sent;
                                        filteredLinkedBookingCustomers = linkedBookingCustomers.filter(function (data) {
                                            return data;
                                        });

                                        if (!(bookingIds.length > 0)) {
                                            _context.next = 42;
                                            break;
                                        }

                                        _context.next = 24;
                                        return (0, _effects.put)({ type: _roomingListsDataActions.ROOMING_LISTS_DATA_REQUESTED });

                                    case 24:
                                        _context.next = 26;
                                        return (0, _effects.race)({
                                            roomingListAction: (0, _effects.take)(_roomingListsDataActions.ROOMING_LISTS_DATA_RECEIVED),
                                            roomingListRequestFailed: (0, _effects.take)(_roomingListsDataActions.ROOMING_LISTS_DATA_REQUEST_FAILED)
                                        });

                                    case 26:
                                        _ref2 = _context.sent;
                                        roomingListAction = _ref2.roomingListAction;

                                        if (roomingListAction) {
                                            _context.next = 32;
                                            break;
                                        }

                                        _context.next = 31;
                                        return (0, _effects.put)((0, _bookingDataActions.linkedBookingCustomersDataReceived)(filteredLinkedBookingCustomers));

                                    case 31:
                                        return _context.abrupt("return", "continue");

                                    case 32:
                                        roomingListData = roomingListAction.roomingListData || [];
                                        // Build both rooming-id sets in one pass over rooming list entries.

                                        roomingListCustomerIdsSet = new _set2.default();
                                        myOwnRoomCustomerIdsSet = new _set2.default();


                                        roomingListData.forEach(function (entry) {
                                            if (!Array.isArray(entry.customers)) {
                                                return;
                                            }

                                            entry.customers.forEach(function (customerEntry) {
                                                var customerId = customerEntry.customer && customerEntry.customer.id;
                                                if (!customerId) {
                                                    return;
                                                }

                                                var normalizedId = String(customerId);
                                                roomingListCustomerIdsSet.add(normalizedId);

                                                if (entry.reason === "MY_OWN_ROOM") {
                                                    myOwnRoomCustomerIdsSet.add(normalizedId);
                                                }
                                            });
                                        });

                                        // Keep only customers that exist in rooming lists and are not MY_OWN_ROOM.
                                        allowedRoomingCustomerIds = new _set2.default((0, _from2.default)(roomingListCustomerIdsSet).filter(function (id) {
                                            return !myOwnRoomCustomerIdsSet.has(id);
                                        }));

                                        // Keep only linked booking customers whose ids are allowed for rooming.

                                        roomingEligibleLinkedBookingCustomers = filterBookingCustomersByAllowedIds(filteredLinkedBookingCustomers, allowedRoomingCustomerIds);
                                        _context.next = 40;
                                        return (0, _effects.put)((0, _bookingDataActions.linkedBookingCustomersDataReceived)(roomingEligibleLinkedBookingCustomers));

                                    case 40:
                                        _context.next = 44;
                                        break;

                                    case 42:
                                        _context.next = 44;
                                        return (0, _effects.put)((0, _bookingDataActions.linkedBookingCustomersDataReceived)(filteredLinkedBookingCustomers));

                                    case 44:
                                    case "end":
                                        return _context.stop();
                                }
                            }
                        }, _loop, _this);
                    });

                case 1:
                    if (!true) {
                        _context2.next = 8;
                        break;
                    }

                    return _context2.delegateYield(_loop(), "t0", 3);

                case 3:
                    _ret = _context2.t0;

                    if (!(_ret === "continue")) {
                        _context2.next = 6;
                        break;
                    }

                    return _context2.abrupt("continue", 1);

                case 6:
                    _context2.next = 1;
                    break;

                case 8:
                case "end":
                    return _context2.stop();
            }
        }
    }, _marked, this);
}

exports.default = fetchLinkedBookingsCustomerData;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/sagas/fetchLinkedBookingsCustomerData.js
// module id = 1413
// module chunks = 0